import type { components } from "@sagot/api-client";
import { useTranslation } from "@sagot/i18n";
import { Avatar, RadioGroup } from "@sagot/ui";

type PageOut = components["schemas"]["PageOut"];

interface PagePickerProps {
  pages: readonly PageOut[];
  value: string | null;
  onValueChange: (pageId: string) => void;
}

/** Radio cards of the Facebook Pages the signed-in admin manages. */
export function PagePicker({ pages, value, onValueChange }: PagePickerProps) {
  const { t } = useTranslation();
  return (
    <RadioGroup
      aria-label={t("deployKnowledge.metaCallback.pagesLabel")}
      variant="cards"
      value={value ?? ""}
      onValueChange={onValueChange}
      options={pages.map((page) => ({
        value: page.id,
        label: (
          <span className="flex items-center gap-3">
            <Avatar name={page.name} className="size-9 text-[10px]" />
            <span className="font-semibold">{page.name}</span>
          </span>
        ),
        description: page.category ?? t("deployKnowledge.metaCallback.noCategory"),
      }))}
    />
  );
}
